import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_kitchen_flatware: FaireCategoryEntity = {
  token: "cat_kitchen-flatware",
  type: "category",
  name: "Flatware & serveware",
  level: 3,
  parentToken: "cat_home-decor-kitchen-tabletop",
  href: "/category/home-decor/kitchen-tabletop/flatware-serveware",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
